import styled from 'styled-components';
import { TextPairing } from '@components/TextPairing';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { Flex } from '@components/Flex';

export const RSVPTextPairing = styled(TextPairing)`
  h2 {
    max-width: 500px;
  }
  p {
    max-width: 663px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 650px;
    }
  }
`;

export const RsvpPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  padding-top: ${themeSpace(11)};
  width: 600px;
  height: 514px;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: auto;
    padding-top: ${themeSpace(0)};
    margin-bottom: ${themeSpace(11)};
  }
  ${themeMediaQuery('sm')} {
    width: 295px;
    height: 462px;
    margin-left: -14%;
    padding-top: ${themeSpace(15)};
  }
  ${themeMediaQuery('md')} {
    width: 504px;
    height: 462px;
    margin-left: -8%;
    padding-top: ${themeSpace(11)};
  }
  @media (min-width: 1400px) {
    margin-left: -14%;
  }
  ${themeMediaQuery('lg')} {
    margin-left: -14%;
  }
  ${themeMediaQuery('xl')} {
    width: 600px;
    height: 514px;
    margin-left: -25%;
    padding-top: ${themeSpace(11)};
  }
`;

export const StyledImageContainer = styled.div`
  width: 72px;
  height: 72px;
  text-align: center;
  border-radius: 50%;
  background: rgba(117, 156, 255, 0.1);
`;

export const StyledPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  position: relative;
  top: 15px;
`;

export const StyledText = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    text-align: center;
    align-items: center;
  }
`;

export const FeatureText = styled(TextPairing)`
  margin-top: ${themeSpace(4)};
  .text-pairing-body {
    max-width: 215px;
    ${themeMediaQuery('below_sm')} {
      text-align: center;
      align-items: center;
    }
  }
  .text-pairing-title {
    ${themeMediaQuery('sm')} {
      font-size: 15px;
    }
    ${themeMediaQuery('below_sm')} {
      text-align: center;
      align-items: center;
    }
  }
  ${themeMediaQuery('below_sm')} {
    text-align: center;
    align-items: center;
  }
`;
